import getEmployeeId from "utils/commonAdmin";
import requests from "./httpService";


const AgentsServices = {
  getAllAgents: async (type, payload) => {
    return requests.post(`/agent/${type}`, payload);
  },

  getAgentList: async () =>{
    return requests.get(`/client/agentlist/`)
  },

  getAgentsOnlineStatus: async () => {
    return requests.get(`/agent/online-status`);
  },

  addAgents: async (body) => {
    return requests.post(`/agent/registration`, body);
  },

  getAgentsById: async (id) => {
    return requests.get(`/agent/getById/${id}`);
  },

  updateAgents: async (id, body) => {
    return requests.put(`/agent/update/${id}`, body);
  },

  updateAgentsStatus: async (id, body) => {
    return requests.patch(`/agent/active-inactive/${id}`, body);
  },

  updateAgentsBlock: async (id, body) => {
    return requests.put(`/agent/block-unblock/${id}`, body);
  },

  getRemarksById: async (id) => {
    return requests.get(`/agent/getStatusRemarksById/${id}`);
  },
getAgentProfileHistory: async (id) => {
  return requests.get(`/agent/${id}/history`);
}
,
AgentProfileApprovalUpdate: async (body) => {
  const id_employee = await getEmployeeId();
  return requests.put(`/agent/profile/update-approval/${id_employee}`,body);
},
  deleteAgents: async (id) => {
    return requests.put(`/agent/delete/${id}`);
  },

  getAllReferenceNo:async(id,body) =>{
    return requests.get(`/agent/reference`, body);
  },

  updateAgentsBlockStatus:async(id,body) =>{
    return requests.put(`/agent/blockStatus/${id}`, body);
  },

  getTransportHead: async() =>{
    return requests.get(`/agent/transportmanager/`);
  },

  getSeller: async() =>{
    return requests.get(`/agent/seller`);
  },
  changeStatus: async (id,body) => {
  
    return requests.put(`/agent/status/${id}`,body);
  },
   agentType: async (id,body) => {
  
    return requests.put(`/agent/agentType/${id}`,body);
  }
};

export default AgentsServices;
